/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
:host([disabled]) {
  cursor: default;
  -webkit-user-select: none;
          user-select: none;
  opacity: var(--calcite-opacity-disabled);
}

:host([disabled]) *,
:host([disabled]) ::slotted(*) {
  pointer-events: none;
}

/**
* CSS Custom Properties
*
* These properties can be overridden using the component's tag as selector.
*
* @prop --calcite-dropdown-width: Specifies the width of the component's wrapper.
*/
:host {
  display: inline-block;
}

:host([disabled]) ::slotted([calcite-hydrated][disabled]),
:host([disabled]) [calcite-hydrated][disabled] {
  /* prevent opacity stacking */
  opacity: 1;
}

.interaction-container {
  display: contents;
}

:host .calcite-dropdown-wrapper {
  --calcite-floating-ui-z-index: var(--calcite-z-index-dropdown);
  display: block;
  position: absolute;
  z-index: var(--calcite-floating-ui-z-index);
  visibility: hidden;
}

.calcite-dropdown-wrapper .calcite-floating-ui-anim {
  position: relative;
  transition: var(--calcite-floating-ui-transition);
  transition-property: inset, left, opacity;
  opacity: 0;
  box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.16);
  z-index: var(--calcite-z-index);
  border-radius: 0.25rem;
}
.calcite-dropdown-wrapper[data-placement^=bottom] .calcite-floating-ui-anim {
  inset-block-start: -5px;
}
.calcite-dropdown-wrapper[data-placement^=top] .calcite-floating-ui-anim {
  inset-block-start: 5px;
}
.calcite-dropdown-wrapper[data-placement^=left] .calcite-floating-ui-anim {
  left: 5px;
}
.calcite-dropdown-wrapper[data-placement^=right] .calcite-floating-ui-anim {
  left: -5px;
}
.calcite-dropdown-wrapper[data-placement] .calcite-floating-ui-anim--active {
  opacity: 1;
  inset-block: 0;
  left: 0;
}

:host([open]) .calcite-dropdown-wrapper {
  visibility: visible;
}

:host .calcite-dropdown-content {
  max-block-size: 45vh;
  inline-size: auto;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: var(--calcite-color-foreground-1);
  inline-size: var(--calcite-dropdown-width);
}

.calcite-trigger-container {
  position: relative;
  display: flex;
  block-size: 100%;
  flex: 1 1 auto;
  word-wrap: break-word;
  word-break: break-word;
}

@media (forced-colors: active) {
  /* use real border since box-shadow is removed in high contrast mode */
  :host([open]) .calcite-dropdown-wrapper {
    border: 1px solid canvasText;
  }
}
:host([width-scale=s]) {
  --calcite-dropdown-width: 12rem;
}

:host([width-scale=m]) {
  --calcite-dropdown-width: 14rem;
}

:host([width-scale=l]) {
  --calcite-dropdown-width: 16rem;
}

:host([hidden]) {
  display: none;
}

[hidden] {
  display: none;
}